PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX skin: <http://purl.obolibrary.org/obo/UBERON_0002097>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

CONSTRUCT {
  ?refOrgan rdf:type ccf:SpatialSceneNode ;
    ccf:representation_of ?representation_of ;
    ccf:has_reference_organ ?refOrgan ;
    ccf:organ_owner_sex ?sex ;
    ccf:file_url ?file ;
    ccf:file_subpath ?file_subpath ;
    ccf:tooltip ?label ;
    ccf:rui_rank ?rui_rank ;
    ccf:has_object_reference ?object .
}
FROM HRA:
WHERE {
  {
    ?refOrgan rdf:type ccf:SpatialEntity ;
              ccf:has_reference_organ ?refOrgan ;
              ccf:has_reference_organ ?realRefOrgan ;
              ccf:representation_of ?representation_of ;
              skos:prefLabel ?label ;
              ccf:organ_owner_sex ?sex ;
              ccf:has_object_reference ?object .
    ?object rdf:type ccf:SpatialObjectReference ;
            ccf:file_url ?file ;
            ccf:file_subpath ?file_subpath .
    BIND(IF(?representation_of = skin:, 10, 20) as ?rui_rank)
    #{{ORGAN_FILTER}}
  }
}
ORDER BY ?rui_rank ?label
